export enum ViewEnum {
    About = "About",
    Home = "Home"
}


// WEBPACK FOOTER //
// ./src/models/view.ts